import proofTypes from './components/proof-of-ownership/proofTypes';

export default {
    userName: '',
    userNameValid: false,
    password: '',
    passwordValid: false,
    proofOfOwnershipValue: '',
    proofOfOwnershipType: proofTypes.CUSTOMER_NUMBER,
    isFormComplete: false,
    isProcessing: false,
    isSubmitSuccessful: false,
    navigateBack: false,
    validationErrors: [],
    isShowRadioMobile: false
};


// WEBPACK FOOTER //
// ./src/modules/account-connector/initialState.js